import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="App">
      <Navbar />
      <div className="max-w-lg mx-auto px-4 py-24 text-center animate-fade-up">
        <XCircle className="h-14 w-14 text-muted-foreground mx-auto" />
        <h1 className="font-heading text-3xl font-semibold mt-6">Plată anulată</h1>
        <p className="text-muted-foreground mt-2">Rezervarea nu a fost finalizată. Poți încerca din nou oricând.</p>
        <Button onClick={() => navigate("/")} className="rounded-full mt-6 bg-accent hover:bg-accent/90 text-accent-foreground">
          Înapoi la cazări
        </Button>
      </div>
    </div>
  );
}
